import React, { useEffect, useState } from "react";
import classnames from "classnames";

import {
  TabContent,
  TabPane,
  Nav,
  NavItem,
  NavLink,
  Button,
  Row,
  Col,
  Container,
  Form,
  FormGroup,
  Label,
  Input,
  FormFeedback,
  Card,
  Tooltip,
} from "reactstrap";
import AgencyChangePassword from "./AgencyChangePassword";
import { useDispatch, useSelector } from "react-redux";
import { getLoggedAgencyDetails } from "../../../redux/actions";
import { getAgencyId } from "../../common/CommonFunctions";
import { AGENCY_UPDATE_URL, UPLOAD_FILE } from "../../../constants/ApiPaths";
import { CustomAlertMessage } from "../../../functions/CustomFunctions";
import API from "../../../redux/actions/API";
import { useSnackbar } from "notistack";
import { useFormik } from "formik";
import { authHeader } from "../../../functions/CoreFunctions";
import * as Yup from "yup";
import CustomButtonLoader from "../../CustomComponents/CustomButtonLoader";
import MyProfile from "./MyProfile";
import CustomPageLoading from "../../CustomComponents/CustomPageLoading";
import { Info } from "../../common/Info";

function AgencySettings(props) {
  const dispatch = useDispatch();
  const Delete = useSelector((state) => state.Agencydelete);

  const [activeTab, setActiveTab] = useState("1");
  const [imageLoading, setImageLoading] = useState(false);
  const [id, setid] = useState("");
  const [tooltipOpen, setTooltipOpen] = useState(false);

  const tooltiptoggle = (id) => {
    setid(id);
    setTooltipOpen(!tooltipOpen);
  };
  const toggle = (tab) => {
    if (activeTab !== tab) setActiveTab(tab);
  };
  const { enqueueSnackbar } = useSnackbar();

  const [formData, setFormData] = useState({
    agencyId: "",
    agencyName: "",
    ttid: "",
    taxId: "",
    accountNumber: "",
    accountHolderName: "",
    bankAddress: "",
    ifscCode: "",
    agencyLogo: "",
    stateId: "",
    stateName: "",
    city: "",
    address: "",
    zip: "",
    phoneNumber: "",
    agencyEmail: "",
    agencyFax: "",
    routingNumber: "",
    agencyUrl: "",
  });
  useEffect(() => {
    dispatch(getLoggedAgencyDetails(getAgencyId()));
  }, []);
  //reducer- agency details
  const details = useSelector((state) => state.AgencyDetailsReducer);
  const { loading = false } = details;
  console.log(details, formData);
  useEffect(() => {
    setFormData({
      ...formData,
      ...details,
    });
  }, [details]);
  // validation schema
  Yup.addMethod(Yup.string, "phoneNumberValidation", function (errorMessage) {
    return this.test(`test-card-type`, errorMessage, function (value) {
      const { path, createError } = this;
      if (value) {
        let v1 = value;
        if (value.includes("+1 ")) {
          v1 = value.split("+1 ")[1];
        } else {
          // Handle the case where "+1 " is not present
          v1 = value;
        }

        var num = v1.replace(/\D+/g, "");
        var check = v1.match(/[A-Za-z_@./#&+!^*+=,:;]/) ? false : true;
        let Pass = num.length <= 10;
        return (check && Pass) || createError({ path, message: errorMessage });
      } else {
        return createError({ path, message: "Phone Number is Required" });
      }
    });
  });
  const validationSchema = Yup.object({
    agencyName: Yup.string().trim().required("Agency Name is required"),
    ttid: Yup.string().trim().required("Location is required"),
    phoneNumber: Yup.string().phoneNumberValidation("Invalid Phone Number"),
    accountNumber: Yup.string().trim().required("Account Number is required"),
    accountHolderName: Yup.string()
      .trim()
      .required("Account Holder Name is required"),
    bankAddress: Yup.string().trim().required("Bank Address is required"),
    // ifscCode: Yup.string().trim().required("IFSC code is required"),
    routingNumber: Yup.string()
      .min(9, "Routing Number is not Valid")
      .max(9, "Routing Number is not Valid")
      .required("Routing Number is required!"),
    stateName: Yup.string().trim().required("State is required"),
    city: Yup.string().trim().required("City is required"),
    address: Yup.string().trim().required("Address is required"),
    zip: Yup.string().trim().required("Zip is required"),
    // agencyFax: Yup.string().trim().required("Fax is required"),
  });
  const saveFormValues = async (values) => {
    if (Delete) return;

    const agencyId = getAgencyId();
    const config = {
      method: "PUT",
      url: AGENCY_UPDATE_URL,
      data: {
        ...values,
        agencyId: parseInt(agencyId),

        phoneNumber: values.phoneNumber.includes("+1")
          ? values.phoneNumber.split("+1 ")[1]
          : values.phoneNumber,
      },
      headers: authHeader(),
    };

    try {
      const response = await API(config);
      const { status } = response.data;

      if (status === "Success") {
        CustomAlertMessage(
          "Profile Updated Successfully!",
          "success",
          enqueueSnackbar
        );

        dispatch(getLoggedAgencyDetails(agencyId));
      }
    } catch (error) {
      let { data } = error.response;

      CustomAlertMessage(data.message, "error", enqueueSnackbar);
    } finally {
    }
  };
  //Formik
  const { handleSubmit, handleChange, values, errors, touched } = useFormik({
    initialValues: formData,
    enableReinitialize: true,
    validationSchema,
    onSubmit: (values) => saveFormValues(values),
  });
  const choosenImage = async (event) => {
    setImageLoading(true);
    const file = new FormData();
    file.append("file", event.target.files[0]);
    if (!event.target.files[0]) return;
    const config = {
      method: "POST",
      url: UPLOAD_FILE,
      headers: authHeader(),
      data: file,
      "content-type": "multipart/form-data",
    };

    try {
      const response = await API(config);
      const { filePath, status } = response.data;
      if (status === "Success") {
        setFormData({
          ...formData,
          agencyLogo: filePath,
        });
      }
    } catch (error) {
      console.error(error);
      let { data } = error.response;

      CustomAlertMessage(data.message, "error", enqueueSnackbar);
    } finally {
      setImageLoading(false);
    }
  };

  return (
    <div>
      <div className="agency-wrapper">
        <Container fluid>
          <div className="page-title">
            <h4>
              Settings
              <Tooltip
                isOpen={id === "settings" && tooltipOpen}
                target={"settings"}
                toggle={() => tooltiptoggle("settings")}
              >
                Personal account settings information
              </Tooltip>
              <span id={"settings"}>
                <Info />
              </span>
            </h4>
          </div>
          <Card body className="mt-4">
            <Nav tabs>
              <NavItem>
                <NavLink
                  className={classnames({ active: activeTab === "1" })}
                  onClick={() => {
                    toggle("1");
                  }}
                >
                  My Profile
                  <Tooltip
                    isOpen={id === "myprofile" && tooltipOpen}
                    target={"myprofile"}
                    toggle={() => tooltiptoggle("myprofile")}
                  >
                    Personal admin profile information
                  </Tooltip>
                  <span id={"myprofile"}>
                    <Info />
                  </span>
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink
                  className={classnames({ active: activeTab === "2" })}
                  onClick={() => {
                    toggle("2");
                  }}
                >
                  Agency Profile
                  <Tooltip
                    isOpen={id === "agencyprovfile" && tooltipOpen}
                    target={"agencyprovfile"}
                    toggle={() => tooltiptoggle("agencyprovfile")}
                  >
                    Agency profile information
                  </Tooltip>
                  <span id={"agencyprovfile"}>
                    <Info />
                  </span>
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink
                  className={classnames({ active: activeTab === "3" })}
                  onClick={() => {
                    toggle("3");
                  }}
                >
                  Security
                  <Tooltip
                    isOpen={id === "seccurity" && tooltipOpen}
                    target={"seccurity"}
                    toggle={() => tooltiptoggle("seccurity")}
                  >
                    Account security information
                  </Tooltip>
                  <span id={"seccurity"}>
                    <Info />
                  </span>
                </NavLink>
              </NavItem>
            </Nav>

            <TabContent activeTab={activeTab}>
              <TabPane tabId="1">
                <MyProfile />
              </TabPane>
              <TabPane tabId="2">
                <Form form="true" onSubmit={handleSubmit}>
                  <div className="page agency-setting">
                    <Row className="item-center">
                      <Col md="3"></Col>
                      <Col md="4" className="item-center">
                        {imageLoading && <CustomPageLoading />}

                        <div className="user-box">
                          <img src={values.agencyLogo} alt=""/>
                          <p>Edit agency logo</p>

                          <div className="upload-btn-wrapper">
                            <button className="upload-btn">
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="19.407"
                                height="16.981"
                                viewBox="0 0 19.407 16.981"
                              >
                                <path
                                  id="Icon_awesome-camera"
                                  data-name="Icon awesome-camera"
                                  d="M19.407,6.5V17.412a1.82,1.82,0,0,1-1.819,1.819H1.819A1.82,1.82,0,0,1,0,17.412V6.5A1.82,1.82,0,0,1,1.819,4.676H5.155l.466-1.247a1.817,1.817,0,0,1,1.7-1.179H12.08a1.817,1.817,0,0,1,1.7,1.179l.47,1.247h3.336A1.82,1.82,0,0,1,19.407,6.5Zm-5.155,5.458A4.549,4.549,0,1,0,9.7,16.5,4.552,4.552,0,0,0,14.252,11.954Zm-1.213,0A3.336,3.336,0,1,1,9.7,8.618,3.341,3.341,0,0,1,13.039,11.954Z"
                                  transform="translate(0 -2.25)"
                                  fill="#d51d1d"
                                />
                              </svg>
                            </button>
                            <input
                              type="file"
                              name="agencyLogo"
                              accept=".png, .jpg"
                              onChange={choosenImage}
                            />
                          </div>
                        </div>
                      </Col>
                    </Row>
                  </div>
                  <Row>
                    <Col sm="12">
                      <Container fluid>
                        <div className="form">
                          <div className="sub-title">
                            <h5>Personal Details</h5>
                          </div>

                          <Row>
                            <Col md="4">
                              <FormGroup>
                                <Label for="agencyName">Agency Name</Label>
                                <Input
                                  type="text"
                                  name="agencyName"
                                  id="agencyName"
                                  placeholder="Agency Name"
                                  value={values.agencyName}
                                  invalid={
                                    errors.agencyName && touched.agency
                                      ? true
                                      : false
                                  }
                                  onChange={handleChange}
                                />
                                <FormFeedback>
                                  {errors.agencyName && touched.agencyName
                                    ? errors.agencyName
                                    : ""}
                                </FormFeedback>
                              </FormGroup>
                            </Col>
                            <Col md="4">
                              <FormGroup>
                                <Label for="email">Email</Label>
                                <Input
                                  type="email"
                                  name="agencyEmail"
                                  id="gencyEmail"
                                  placeholder="Email"
                                  disabled={true}
                                  value={values.agencyEmail}
                                  invalid={
                                    errors.gencyEmail && touched.gencyEmail
                                      ? true
                                      : false
                                  }
                                  onChange={handleChange}
                                />
                                <FormFeedback>
                                  {errors.gencyEmail && touched.gencyEmail
                                    ? errors.gencyEmail
                                    : ""}
                                </FormFeedback>
                              </FormGroup>
                            </Col>
                            <Col md="4">
                              <FormGroup>
                                <Label for="phoneNumber">Phone Number</Label>
                                <Input
                                  type="tel"
                                  name="phoneNumber"
                                  id="phoneNumber"
                                  placeholder="Phone Number"
                                  value={values.phoneNumber}
                                  invalid={
                                    errors.phoneNumber && touched.phoneNumber
                                      ? true
                                      : false
                                  }
                                  onChange={handleChange}
                                />
                                <FormFeedback>
                                  {errors.phoneNumber && touched.phoneNumber
                                    ? errors.phoneNumber
                                    : ""}
                                </FormFeedback>
                              </FormGroup>
                            </Col>
                          </Row>

                          <Row>
                            <Col md="4">
                              <FormGroup>
                                <Label for="agencyFax">Fax</Label>
                                <Input
                                  type="text"
                                  name="agencyFax"
                                  id="agencyFax"
                                  placeholder="Fax"
                                  value={values.agencyFax}
                                  invalid={
                                    errors.agencyFax && touched.agencyFax
                                      ? true
                                      : false
                                  }
                                  onChange={handleChange}
                                />
                                <FormFeedback>
                                  {errors.agencyFax && touched.agencyFax
                                    ? errors.agencyFax
                                    : ""}
                                </FormFeedback>
                              </FormGroup>
                            </Col>
                            <Col md="4">
                              <FormGroup>
                                <Label for="address">Address</Label>
                                <Input
                                  type="text"
                                  name="address"
                                  id="address"
                                  placeholder="Address"
                                  value={values.address}
                                  invalid={
                                    errors.address && touched.address
                                      ? true
                                      : false
                                  }
                                  onChange={handleChange}
                                />
                                <FormFeedback>
                                  {errors.address && touched.address
                                    ? errors.address
                                    : ""}
                                </FormFeedback>
                              </FormGroup>
                            </Col>
                            <Col md="4">
                              <FormGroup>
                                <Label for="city">City</Label>
                                <Input
                                  type="text"
                                  name="city"
                                  id="city"
                                  placeholder="City"
                                  value={values.city}
                                  invalid={
                                    errors.city && touched.city ? true : false
                                  }
                                  onChange={handleChange}
                                />
                                <FormFeedback>
                                  {errors.city && touched.city
                                    ? errors.city
                                    : ""}
                                </FormFeedback>
                              </FormGroup>
                            </Col>
                          </Row>

                          <Row>
                            <Col md="4">
                              <FormGroup>
                                <Label for="state">State</Label>
                                <Input
                                  type="text"
                                  name="state"
                                  id="state"
                                  placeholder="State"
                                  value={values.stateName}
                                  invalid={
                                    errors.stateName && touched.stateName
                                      ? true
                                      : false
                                  }
                                  onChange={handleChange}
                                />
                                <FormFeedback>
                                  {errors.stateName && touched.stateName
                                    ? errors.stateName
                                    : ""}
                                </FormFeedback>
                              </FormGroup>
                            </Col>
                            <Col md="4">
                              <FormGroup>
                                <Label for="zip">Zip</Label>
                                <Input
                                  type="tel"
                                  name="zip"
                                  id="zip"
                                  placeholder="Zip"
                                  value={values.zip}
                                  invalid={
                                    errors.zip && touched.zip ? true : false
                                  }
                                  onChange={handleChange}
                                />
                                <FormFeedback>
                                  {errors.zip && touched.zip ? errors.zip : ""}
                                </FormFeedback>
                              </FormGroup>
                            </Col>
                            {/* <Col md="4">
                              <FormGroup>
                                <Label for="ttid">Location Code</Label>
                                <Input
                                  type="tel"
                                  name="ttid"
                                  id="ttid"
                                  placeholder="Location code"
                                  value={values.ttid}
                                  invalid={
                                    errors.ttid && touched.ttid ? true : false
                                  }
                                  onChange={handleChange}
                                />
                                <FormFeedback>
                                  {errors.ttid && touched.ttid
                                    ? errors.ttid
                                    : ""}
                                </FormFeedback>
                              </FormGroup>
                            </Col> */}
                          </Row>

                          {/* {RootUser === "true" ? (
                            <>
                              <div className="sub-title mt-5">
                                <h5>Bank Details</h5>
                              </div>

                              <Row>
                                <Col md="4">
                                  <FormGroup>
                                    <Label for="accountNumber">
                                      Account Number
                                    </Label>
                                    <Input
                                      type="tel"
                                      name="accountNumber"
                                      id="accountNumber"
                                      placeholder="Account number"
                                      value={values.accountNumber}
                                      invalid={
                                        errors.accountNumber &&
                                        touched.accountNumber
                                          ? true
                                          : false
                                      }
                                      onChange={handleChange}
                                    />
                                    <FormFeedback>
                                      {errors.accountNumber &&
                                      touched.accountNumber
                                        ? errors.accountNumber
                                        : ""}
                                    </FormFeedback>
                                  </FormGroup>
                                </Col>
                                <Col md="4">
                                  <FormGroup>
                                    <Label for="accountHolderName">
                                      Holder Name
                                    </Label>
                                    <Input
                                      type="tel"
                                      name="accountHolderName"
                                      id="accountHolderName"
                                      placeholder="Holder name"
                                      value={values.accountHolderName}
                                      invalid={
                                        errors.accountHolderName &&
                                        touched.accountHolderName
                                          ? true
                                          : false
                                      }
                                      onChange={handleChange}
                                    />
                                    <FormFeedback>
                                      {errors.accountHolderName &&
                                      touched.accountHolderName
                                        ? errors.accountHolderName
                                        : ""}
                                    </FormFeedback>
                                  </FormGroup>
                                </Col>
                                <Col md="4">
                                  <FormGroup>
                                    <Label for="routingNumber">
                                      Routing Number
                                    </Label>
                                    <Input
                                      type="tel"
                                      name="routingNumber"
                                      id="routingNumber"
                                      placeholder="Routing Number"
                                      value={values.routingNumber}
                                      invalid={
                                        errors.routingNumber &&
                                        touched.routingNumber
                                          ? true
                                          : false
                                      }
                                      onChange={handleChange}
                                    />
                                    <FormFeedback>
                                      {errors.routingNumber &&
                                      touched.routingNumber
                                        ? errors.routingNumber
                                        : ""}
                                    </FormFeedback>
                                  </FormGroup>
                                </Col>
                                <Col md="4">
                                  <FormGroup>
                                    <Label for="bankAddress">
                                      Bank Address
                                    </Label>
                                    <Input
                                      type="tel"
                                      name="bankAddress"
                                      id="bankAddress"
                                      placeholder="Bank address"
                                      value={values.bankAddress}
                                      invalid={
                                        errors.bankAddress &&
                                        touched.bankAddress
                                          ? true
                                          : false
                                      }
                                      onChange={handleChange}
                                    />
                                    <FormFeedback>
                                      {errors.ifscCode && touched.ifscCode
                                        ? errors.ifscCode
                                        : ""}
                                    </FormFeedback>
                                  </FormGroup>
                                </Col>
                              </Row>
                            </>
                          ) : (
                            ""
                          )} */}
                        </div>

                        <Button
                          color="primary"
                          disabled={Delete}
                          className="d-block m-auto"
                          type="submit"
                        >
                          {loading && <CustomButtonLoader loading={loading} />}
                          Update
                        </Button>
                      </Container>
                    </Col>
                  </Row>
                </Form>
              </TabPane>
              <TabPane tabId="3">
                <AgencyChangePassword />
              </TabPane>
            </TabContent>
          </Card>
        </Container>
      </div>
    </div>
  );
}

export default AgencySettings;
